import { Section } from '@/components/shared/Content';
import { Flex } from '@lemonade-hq/cdk';
import styled from 'styled-components';
import { GBSectionParagraph, GBSectionTitle } from './StyledElements';
import type { FC } from 'react';

const ContentWrapper = styled(Flex)`
  max-width: 800px;
`;

export interface InternalImpactProps {
  title: string;
  p1: string;
}

export const InternalImpact: FC<InternalImpactProps> = ({ title, p1 }) => {
  return (
    <Section py={[50, 50, 96]} px={20}>
      <GBSectionTitle>{title}</GBSectionTitle>
      <ContentWrapper flexDirection="column" alignItems="center" mt={20}>
        <GBSectionParagraph>{p1}</GBSectionParagraph>
      </ContentWrapper>
    </Section>
  );
};
